function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useRef } from "react";
import OnColorContext from "../../../contexts/OnColorContext";
import { getFocusableElementsInWrapper } from "../../../hooks/useFocusWrapper";
import { KeyboardEventKeys } from "../../../typings/types";
import RelativeContainerOrg from "../../organisms/RelativeContainerOrg";
import { StyledContainer, StyledContent, StyledTabContainer, StyledTabHeader, StyledTabItem, StyledTabsContainer } from "./DomainSearchTabsMol.styled";
export var defaultBackgroundColor = "background";
export var defaultActiveBackgroundColor = "backgroundDarkLight";
export default function DomainSearchTabsMol(_ref) {
  var tabs = _ref.tabs,
    activeTabIndex = _ref.activeTabIndex,
    minHeightSpace = _ref.minHeightSpace,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? defaultBackgroundColor : _ref$backgroundColor,
    _ref$activeBackground = _ref.activeBackgroundColor,
    activeBackgroundColor = _ref$activeBackground === void 0 ? defaultActiveBackgroundColor : _ref$activeBackground,
    switchTabsOnBlur = _ref.switchTabsOnBlur;
  var elementRef = useRef(null);
  var contentRef = useRef(null);
  var tabsHeaderRef = useRef([]);
  var _useState = useState(activeTabIndex),
    _useState2 = _slicedToArray(_useState, 2),
    activeIndex = _useState2[0],
    setActiveIndex = _useState2[1];
  var contentJSX = tabs[activeIndex].content;
  var handleTabItemClick = function handleTabItemClick(event, tab, index) {
    var setFocus = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    event.preventDefault();
    contentJSX = tab.content;
    setActiveIndex(index);
    tab.onClick();
    if (setFocus) {
      var _tabsHeaderRef$curren;
      (_tabsHeaderRef$curren = tabsHeaderRef.current[index]) === null || _tabsHeaderRef$curren === void 0 || _tabsHeaderRef$curren.focus();
    }
  };
  var handleTabKeyDown = function handleTabKeyDown(event, tab, index) {
    if (event.key === KeyboardEventKeys.ENTER) {
      handleTabItemClick(event, tab, index);
    }
  };
  var handleOnBlurContent = function handleOnBlurContent(event) {
    var focusableElements = getFocusableElementsInWrapper(contentRef.current);
    var lastFocusableElement = focusableElements[focusableElements.length - 1];
    var activeTab = tabs[activeIndex];
    var firstTabIndexNotInUpperSurface = tabs.findIndex(function (tab) {
      return !tab.isInUpperSurface;
    });
    if (switchTabsOnBlur && event.target === lastFocusableElement && event.relatedTarget !== null && activeTab.isInUpperSurface && firstTabIndexNotInUpperSurface !== -1) {
      handleTabItemClick(event, activeTab, firstTabIndexNotInUpperSurface, false);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: elementRef
  }, /*#__PURE__*/React.createElement(StyledContainer, {
    spacingSpace: 0,
    color: backgroundColor,
    borderRadiusSize: "mlarge",
    $minHeightSpace: minHeightSpace,
    shadow: "tiny"
  }, /*#__PURE__*/React.createElement(RelativeContainerOrg, null, /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: activeBackgroundColor
  }, /*#__PURE__*/React.createElement(StyledTabsContainer, {
    alignItems: "center",
    justifyContent: "center",
    $backgroundColor: backgroundColor
  }, tabs.map(function (tab, index) {
    var isActive = index === activeIndex;
    return /*#__PURE__*/React.createElement(StyledTabContainer, {
      key: tab.title,
      onKeyDown: function onKeyDown(event) {
        return handleTabKeyDown(event, tab, index);
      },
      $isActive: isActive
    }, /*#__PURE__*/React.createElement(StyledTabItem, {
      $isActive: isActive,
      $activeIndex: activeIndex,
      $activeBackgroundColor: activeBackgroundColor,
      onClick: function onClick(event) {
        return handleTabItemClick(event, tab, index);
      },
      title: tab.title
    }, /*#__PURE__*/React.createElement(StyledTabHeader, {
      ref: function ref(_ref2) {
        tabsHeaderRef.current[index] = _ref2;
      },
      role: "button",
      tabIndex: 0
    }, tab.header)));
  }))), /*#__PURE__*/React.createElement(StyledContent, {
    ref: contentRef,
    spacingSpace: 1.5,
    color: activeBackgroundColor,
    borderRadiusSize: "mlarge",
    $activeIndex: activeIndex,
    $hasAbsolutePosition: tabs[activeIndex].isInUpperSurface,
    shadow: tabs[activeIndex].isInUpperSurface ? "tiny" : "none",
    onBlur: handleOnBlurContent,
    role: "search"
  }, contentJSX))));
}